import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const SparkplugIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M10.244 18.2269H12.4287V19.6669H10.244V21.1069H12.316C13.1113 21.1069 13.756 20.4622 13.756 19.6669V16.7868H10.244V18.2268V18.2269ZM10.244 15.3469H13.756V13.9069H10.244V15.3469ZM14.3414 9.71099V5.82024L13.1707 4.64959V2.89355H10.8293V4.64959L9.6587 5.82024V9.71099H8.48798V12.4669H15.512V9.71099H14.3414ZM12.9014 9.71099H11.0987V6.41668L11.8476 5.66778L12 5.51538L12.1525 5.66778L12.9014 6.41668V9.71099Z" />
    </SvgIcon>
  );
});
